"use client";

import "./style.css";
import { useEffect, useRef, useState } from "react";
import { CaretDownIcon, CaretUpIcon } from "@phosphor-icons/react";
import { HTMLContentServer } from "./HTMLContentServer";

interface HTMLContentProps {
  html: TrustedHTML;
  className?: string;
  readMore?: boolean;
  collapsedHeight?: number;
}

export default function HTMLContent({
  html,
  className,
  readMore = false,
  collapsedHeight = 400,
}: HTMLContentProps) {
  const [open, setOpen] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const content = contentRef.current;
    setCanExpand(Boolean(content && content.scrollHeight > collapsedHeight));
  }, [collapsedHeight, html]);

  // If no readMore functionality is needed, use server component for SEO
  if (!readMore) {
    return <HTMLContentServer html={html} className={className} />;
  }

  // For readMore functionality, render server component with toggle button
  const truncated = canExpand && !open;

  return (
    <div className="relative">
      <div ref={contentRef}>
        <HTMLContentServer
          html={html}
          className={className}
          truncated={truncated}
          collapsedHeight={collapsedHeight}
        />
      </div>
      {/* Gradient overlay when truncated */}
      {truncated && (
        <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-24 bg-linear-to-t from-background via-background/85 to-transparent" />
      )}
      {/* Read more button */}
      {canExpand && (
        <div className="relative -mt-5 flex justify-center pb-2">
          <button
            onClick={() => setOpen(!open)}
            className="z-10 flex cursor-pointer items-center gap-1.5 rounded-sm border border-primary bg-background px-4 py-2 text-sm font-medium text-primary shadow-sm transition-all duration-200 hover:bg-primary hover:text-background"
          >
            {open ? (
              <>
                <span>مشاهده کمتر</span>
                <CaretUpIcon className="w-4 h-4" weight="bold" />
              </>
            ) : (
              <>
                <span>مشاهده بیشتر</span>
                <CaretDownIcon className="w-4 h-4" weight="bold" />
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
